<template>
    <div>
        <router-link :to="route + '/' + tool.id" tag="div" v-for="(tool, index) in tools" :key="index">
            <ToolListItem :imageLarge="imageLarge" :tool="tool">
                <template slot="content">
                    <div class="flex items-center justify-between">
                        <div>
                            <div class="mt1 formLabel">Rentals ({{ tool.rentalCount }})</div>
                            <div class="formLabel mid-gray flex items-center">
                                <div>
                                    <img src="@/assets/img/icon_views.svg"/>
                                </div>
                                <div class="flex items-center ml2">
                                    {{ tool.views }}
                                </div>
                            </div>
                        </div>
                        <div class="flex items-center" v-if="xs">
                            <div class="formLabel mid-gray mr1">27</div>
                            <FixedRating  :rating="tool.rating"/>
                        </div>
                    </div>
                </template>                
                <template slot="icon">
                    <RatingBox v-if="!xs" class="flex-none" :rating="tool.rating"/>
                </template>            
            </ToolListItem>
        </router-link>
    </div>
</template>

<script>
import RatingBox from '@/components/controls/RatingBox.vue';
import ToolListItem from '@/components/global/ToolListItem.vue';
import FixedRating from '@/components/global/FixedRating.vue';

export default {
    components: {
        RatingBox,
        ToolListItem,
        FixedRating
    },
    props: {
        tools: {
            type: Array,
            required: true
        },
        route: {
            type: String,
            required: true
        },
        imageLarge: {
            type: Array
        }
    },
    computed: {
        xs() {
            return this.$mq === 'xs';
        }
    }
};
</script>
